module.exports = __webpack_public_path__ + "img/image-modal-failed.a4cad200.svg";